import { render, staticRenderFns } from "./RatingDialog.vue?vue&type=template&id=9c2b0e58"
import script from "./RatingDialog.js?vue&type=script&lang=js&external"
export * from "./RatingDialog.js?vue&type=script&lang=js&external"
import style0 from "./RatingDialog.vue?vue&type=style&index=0&id=9c2b0e58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports